export function isModalShown(state, id) {
  return Object.prototype.hasOwnProperty.call(state.ui.modals, id) && state.ui.modals[id].shown;
}


export function getModalExtra(state, id) {
  return Object.prototype.hasOwnProperty.call(state.ui.modals, id) && state.ui.modals[id].extra ?
    state.ui.modals[id].extra : {};
}
